import styled from 'styled-components'

const theme = {
  open: 'success',
  close: 'black',
}

export const StyledGpsStatus = styled.div<{ variant: string }>`
  position: relative;
  display: flex;
  align-items: center;

  &:before,
  &:after {
    content: '';
  }

  &:before {
    display: block;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background-color: ${props =>
      props.theme.colors[theme[props.variant as keyof typeof theme] as keyof typeof props.theme.colors][300]};
    margin-right: ${props => props.theme.spacing.small};
  }

  &:after {
    position: absolute;
    left: 0.25rem;
    top: 0.35rem;
    display: block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background-color: ${props =>
      props.theme.colors[theme[props.variant as keyof typeof theme] as keyof typeof props.theme.colors][500]};
  }
`
